// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { TransitionGroup } from 'react-transition-group'
import LoadingBar from 'react-redux-loading-bar'
import { Switch, Route, Link } from 'react-router-dom'

// Internal Dependencies:
import MainLayout from 'layouts/MainLayout'
import Page from 'views/page/Page'
import SearchResults from 'components/Search/SearchResults'

import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary'
import CookieConsent from 'components/CookieConsent/CookieConsent'
import LoadingSpinner from 'components/LoadingSpinner/LoadingSpinner'
import HeaderMobilePrimary from 'components/HeaderPrimary/HeaderMobilePrimary'
import HeaderPre from 'components/HeaderPrimary/HeaderPre'
import HeaderPrimary from 'components/HeaderPrimary/HeaderPrimary'
import HeaderSecondary from 'components/HeaderPrimary/HeaderSecondary'
import Menu from 'components/Menu/Menu'
import Footer from 'components/Footer/Footer'

class SiteLayout extends React.Component {
	componentDidMount() {

	}

	componentDidUpdate( prevProps ) {

	}

	render() {
		const { hasSidebar, menuIsOpen, searchIsOpen, searchResults, isLoading, currentlyViewedPage, appendedById, location, match, type, cookieConsent, inGdprZone } = this.props
		let className = '/' == location.pathname ? 'site-wrap is-home' : 'site-wrap'
		let showMainInner = true
		let showSearchResults = false

		if ( 'category' == type ) {
			className += ' is-category'
		}

		if ( 'videos' == type ) {
			className += ' is-videos'
		}

		if ( 'events' == type ) {
			className += ' is-events'
		}

		if ( 'post' == type ) {
			className += ' is-single'
		}

		if ( inGdprZone && null === cookieConsent ) {
			className += ' with-cookie-consent-bar'
		}

		if ( searchIsOpen ) {
			className += ' with-search-open'
		}

		if ( searchIsOpen && searchResults && searchResults.has_results ) {
			showMainInner = false
			showSearchResults = true
			className += ' with-search-results-open'
		}

		if ( 'post' == type && currentlyViewedPage && currentlyViewedPage.page_header_style ) {
			className += ` with-${currentlyViewedPage.page_header_style}`
		}

		return (
			<div className={ className }>
				<CookieConsent />

				<div className="site">
					<HeaderMobilePrimary match={ match } />

					<div className="main-wrap">
						<LoadingBar className="header-loading-bar" updateTime={ 100 } maxProgress={ 90 } progressIncrease={ 10 } />

						<header className="header-wrap">
							<HeaderPre match={ match } />
							<HeaderPrimary match={ match } />
							<HeaderSecondary match={ match } />
						</header>

						<section className="main">
							{ isLoading &&
								<LoadingSpinner />
							}

							{ showSearchResults &&
								<ErrorBoundary>
									<SearchResults />
								</ErrorBoundary>
							}

							{ showMainInner &&
								<ErrorBoundary>
									{ this.props.children }
								</ErrorBoundary>
							}
						</section>
					</div>
				</div>

				<Footer />
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		hasSidebar: state.site.hasSidebar,
		menuIsOpen: state.site.menuIsOpen,
		searchIsOpen: state.search.isOpen,
		searchResults: state.search.searchResults,
		isLoading: state.page.isLoading,
		currentlyViewedPage: state.page.currentlyViewedPage,
		appendedById: state.page.appendedById,
		inGdprZone: state.site.inGdprZone,
		cookieConsent: state.site.cookieConsent
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {

	}
}

export default connect( mapStateToProps, mapDispatchToProps )( SiteLayout )